import type { ApiClient } from '../client';
import type {
  CreateDocumentVerificationRequest,
  CreateDocumentVerificationResponse,
  PublicDocumentVerificationResponse,
} from '../types/document-verifications';

export function bindDocumentVerifications(client: ApiClient) {
  return {
    async createDocumentVerification(body: CreateDocumentVerificationRequest) {
      return client.request<CreateDocumentVerificationResponse>('/documents/verifications', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },

    async verifyDocumentPublic(code: string) {
      const trimmed = (code || '').trim();
      return client.request<PublicDocumentVerificationResponse>(
        `/public/verify/${encodeURIComponent(trimmed)}`,
        { skipAuth: true }
      );
    },
  };
}
